/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NameDescriptionModel } from '../../models/name-description-model';

export interface GetConsequenceStrategyTemplates$Params {
  patientID?: number;
}

export function GetConsequenceStrategyTemplates(http: HttpClient, rootUrl: string, params?: GetConsequenceStrategyTemplates$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<NameDescriptionModel>>> {
  const rb = new RequestBuilder(rootUrl, GetConsequenceStrategyTemplates.PATH, 'get');
  if (params) {
    rb.query('patientID', params.patientID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<NameDescriptionModel>>;
    })
  );
}

GetConsequenceStrategyTemplates.PATH = '/api/Staff/GetConsequenceStrategyTemplates';
